<template>
  <div class="index_pc">
    <div id="headers">
      <p class="logo-img" @click="goPath('home')">
        <img src="./../assets/img/logo3.png" />
        <!-- {{ redirectPath ? "移动端" : "pc" }} -->
      </p>
      <div class="header-content" :class="$i18n.locale == 'CN' ? 'w55' : 'w70'">
        <ul class="nav">
          <li
            :class="light == 'home' ? 'lightHight' : ''"
            @click="goPath('home')"
          >
            {{ currentLg.home }}
          </li>
          <li
            :class="
              light == 'product' || light == 'proDetail' ? 'lightHight' : ''
            "
            @click="goPath('product')"
          >
            {{ currentLg.product }}
          </li>
          <li
            :class="light == 'case' || light == 'caseVeiw' ? 'lightHight' : ''"
            @click="goPath('case')"
          >
            {{ currentLg.case }}
          </li>
          <li
            :class="light == 'about' ? 'lightHight' : ''"
            @click="goPath('about')"
          >
            {{ currentLg.about }}
          </li>
        </ul>
        <div class="line"></div>
        <el-dropdown class="drop" @command="changeLanguage" trigger="click">
          <span class="el-dropdown-link">
            <img class="lg" src="./../assets/img/lg.png" alt="" />
            {{ $i18n.locale == "CN" ? "中文" : "EN"
            }}<img class="down" src="./../assets/img/down.png" alt="" />
          </span>
          <el-dropdown-menu
            slot="dropdown"
            style="padding: 0;top:45px !important"
          >
            <el-dropdown-item command="change">{{
              $i18n.locale == "CN" ? "EN" : "中文"
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <router-view />
    <div class="footers">
      <div class="footers-content">
        <div class="top">
          <p>
            {{ currentLg.address }}
          </p>
        </div>
        <div class="top">
          <p>
            {{ currentLg.Copyright }}
            <span @click="goGxb('https://beian.miit.gov.cn')">{{
              currentLg.gov
            }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import language from "./../language/header/index";
export default {
  name: "App",
  data() {
    return {
      light: "",
      Scroll: 0,
      redirectPath: false,
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    currentLg() {
      return language[this.locale];
    },
  },
  mounted() {
    this.redirectPath = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
    this.light = this.$route.name;
    // window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    changeLanguage() {
      this.$i18n.locale = this.$i18n.locale == "EN" ? "CN" : "EN";
      localStorage.setItem("languageSet", this.$i18n.locale); //将用户设置存储到localStorage以便用户下次打开时使用此设置
    },
    goPath(path) {
      this.light = path;
      this.$router.push({ path: "/index_pc/" + path });
    },
    // handleScroll() {
    //   var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    //   this.Scroll = scrollTop;
    // },
    goGxb(url) {
      window.open(url, "_blank");
    },
  },
  // beforeDestroy() {
  //   window.removeEventListener("click", this.handleScroll);
  // },
};
</script>

<style lang="less" scoped>
.index_pc {
  .logo-img {
    width: 356px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 93px;
      height: 45px;
    }
  }
  #headers {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    z-index: 10;
    height: 8.2vh;
    display: flex;
    background: rgba(0, 0, 0, 0.22);
    .header-content {
      // width: 800px;
      margin: 0 10vw;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 8vh;
      .nav {
        display: flex;
        li {
          font-size: 18px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #ffffff;
          line-height: 8vh;
          margin: 0 1vw;
          text-align: center;
          cursor: pointer;
        }
        li.lightHight {
          color: #fff;
          font-weight: bold;
          border-bottom: 4px solid;
        }
      }
    }
  }

  .positions {
    background-color: #fff;
    position: fixed;
    // z-index: 10000;
    width: 100%;
    left: 0;
    top: 0;
    right: 0;
    .header-content {
      .nav {
        display: flex;
        li.lightHight {
          color: #1982ff;
        }
      }
    }
  }
  .footers {
    background: rgba(46, 48, 51, 1);
    box-sizing: border-box;
    padding: 25px 0;
    .footers-content {
      display: flex;
      box-sizing: border-box;
      justify-content: space-around;
      .top {
        display: flex;
        justify-content: space-between;
        p {
          font-size: 14px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(199, 199, 199, 1);
          line-height: 16px;
          span {
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: rgba(199, 199, 199, 1);
            line-height: 16px;
            cursor: pointer;
          }
        }
      }
    }
  }
  .content-part {
    flex: 1;
  }
}
::-webkit-scrollbar {
  display: none;
}
.line {
  width: 1px;
  height: 26px;
  background: #fff;
  margin: 0 20px;
}
.drop {
  cursor: pointer;
  .el-dropdown-link {
    display: flex;
    align-items: center;
    color: #fff;
    .lg {
      width: 16px;
      margin-right: 6px;
    }
    .down {
      width: 13px;
      margin-left: 6px;
    }
  }
}

.w55 {
  width: 55em;
}
.w70 {
  width: 70em;
}
.el-dropdown-menu {
  top: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/index_pc.vue